import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'

// createApp(App).use(router).use(store).use(Vant).mount('#app')

const app = createApp(App)

app.use(router)
app.use(store)
app.use(Vant)
// 挂载 router 到 window 全局对象
window.$router = router
app.mount('#app')